import { createSlice } from '@reduxjs/toolkit';

export const SizeFamilySlice = createSlice({
    name: 'sizefamily',
    initialState: {
        sizefamily: [],
        sizeFamilyBeneficiarios: []
        
    },
    reducers: {
        setSizeFamilyRedux: ( state, { payload } ) => {
            state.sizefamily  =  payload;
        },
        setBeneficiariosRedux: ( state, { payload } ) => {
            state.sizeFamilyBeneficiarios  =  payload;
        }
        
    }
});


// Action creators are generated for each case reducer function
export const { setSizeFamilyRedux, setBeneficiariosRedux } = SizeFamilySlice.actions;